/**
 * Global constants
 * @type {{I18N_VARNAME: string, APP_CONFIG_VARNAME: string}}
 */
const SystemVars = {
  I18N_VARNAME: 'argoI18n',
  APP_CONFIG_VARNAME: 'argoConfig',
};
export default SystemVars;